<template>
  <div v-loading="loading" class="main-frame">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="24">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                :content="$t('commonInfo.About')"
              ></el-page-header>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <div class="sign-frame">
          <h1
            style="font-size: 28px; font-weight: bold"
          >{{ $t("commonInfo.BackgroundManagementSystem") }}</h1>
          <h3>{{ $t("commonInfo.AboutSystem") }}</h3>
          <h4 style="font-size: 14px; color: #03aef9">
            <span>{{ $t("commonInfo.Version") }}</span>
            {{ current_version }}
          </h4>
          <h5>
            Copyright © {{ new Date().getFullYear() }} Shenzhen IVPS Technology
            Co., Ltd All Rights Reserved.
          </h5>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import config from "../../../package.json";
export default {
  name: "AboutSystemView",
  data: function() {
    return {
      current_version: process.env.VUE_APP_VERSION
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.banner-head {
  /*background-color: white;*/
  background-color: #f1f1f1;
  height: 60px;
}

.head-info {
  color: #ffffff;
}

.sign-frame {
  width: 600px;
  height: 330px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -225px;
  margin-top: -240px;
  /*margin-right: 200px;*/
}

.sign-form {
  margin-top: 50px;
}
</style>